import { FC } from 'react';

type Props = {
	className?: string;
};

const ColorPickerIcon: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M11.1161 6.11133L6.2349 10.9926M6.2349 10.9926L4.42122 12.8062C3.71998 13.5075 3.36936 13.8581 3.18468 14.304C3 14.7498 3 15.2456 3 16.2374V17.0002H3.76286C4.75456 17.0002 5.25041 17.0002 5.69627 16.8156C6.14213 16.6309 6.49275 16.2802 7.19399 15.579L11.7804 10.9926M6.2349 10.9926H11.7804M11.7804 10.9926L13.8889 8.88411'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M15.6059 7.1912L16.8591 8.44445M15.6059 7.1912L16.2762 6.52086C16.5037 6.29335 16.6175 6.17959 16.6966 6.06856C17.1 5.50192 17.1 4.74186 16.6966 4.17522C16.6175 4.06419 16.5037 3.95043 16.2762 3.72292C16.0487 3.49542 15.935 3.38165 15.8239 3.30259C15.2573 2.89914 14.4972 2.89914 13.9306 3.30259C13.8196 3.38165 13.7058 3.4954 13.4783 3.72292L12.8079 4.39326M15.6059 7.1912L12.8079 4.39326M12.8079 4.39326L11.5547 3.14001'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default ColorPickerIcon;
